import React, { useCallback, useContext, useEffect, useState } from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  Button,
  Modal,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Divider,
  Switch,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Skeleton,
  Checkbox,
  Fab,
  Step,
  StepLabel,
  StepContent,
  Stepper,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Rating,
  TextField,
  Snackbar,
  Alert,
  List,
  ListItemAvatar,
  Avatar,
  AvatarGroup,
  Chip,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
} from "@mui/material";
import { MainContext } from '../../../context/main/main-context';
import { debounce } from 'lodash';
import DataHandler from '../../../handlers/DataHandler';
import AddTemplate from './modals/AddTemplate';
import MaterialCustomTablePagination from '../../../components/common/MaterialCustomTablePagination';


function TemplateTab() {

  const {templates, fetchAllTemplates, templateMetaData} = useContext(MainContext);


  const [isOpen, setIsOpen] = useState(false)
  const [templateLoading, setTemplateLoading] = useState(false)
  const [currentTemplate, setCurrentTemplate] = useState(null)

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  
  const [state, setState] = useState({
      limit: 10,
      offset: 0,
      sort_column: 'created_at',
      sort_direction: 'DESC',
    });

  const handlePageChange = (event, newPage) => {

		const newOffset = newPage * rowsPerPage;

		setState((prevState) => ({
			...prevState,
			limit: rowsPerPage,
			offset: newOffset
		}));
		setCurrentPage(newPage)

	};

	const handleRowsPerPageChange = (event) => {

		const newLimit = parseInt(event.target.value, 10);
		const newPage = Math.floor(state.offset / newLimit);

		setState((prevState) => ({
			...prevState,
			limit: newLimit,
			offset: newLimit * newPage
		}));
		setCurrentPage(newPage)

	};

	const handlePageOffsetChange = (newOffset, newPage) => {

		setState((prevState) => ({
			...prevState,
			limit: rowsPerPage,
			offset: newOffset
		}));
		setCurrentPage(newPage)
	};

  const handlefetchAllTemplates = useCallback(
        debounce(async () => {
          const {
            limit,
            offset,
            sort_column,
            sort_direction
          } = state;

          const user_id = DataHandler.getFromSession('manage_user_id');


          setTemplateLoading(true)
    
          try {

            await fetchAllTemplates(limit, offset, sort_column, sort_direction, user_id);

          } catch (error) {
            console.error('Error fetching templates:', error);
          } finally {
            setTemplateLoading(false)
          }
        }, 300),
        [state]
  );

  const addTemplate = () => {
    setIsOpen(true)
  }

  const updateTemplate = (templateData) => {

    if(templateData){
      setCurrentTemplate(templateData)
      setIsOpen(true)
    }
    
  }

  useEffect(() => {
    handlefetchAllTemplates()
  }, [state])
  
  useEffect(() => {
    
    if(templates && templates.success){
      setTemplateLoading(false)
    }
  }, [templates])

  const getPartNotationTypeById = (id) => {
      const notation = templateMetaData?.notations?.find(notation => notation.notation_id === id);
      return notation ? notation.notation_type : "N/A";
  };

  return (
    <Box>
      <Button sx={{ mt: 3, backgroundColor:'#63239A', borderRadius:'8px' }} onClick={addTemplate} variant='contained'>
        Add New Template
      </Button>
      				<Table>

								<TableHead>
									<TableRow>

										<TableCell className="thead">

										</TableCell>

										<TableCell
											className="thead"
											style={{ cursor: "pointer" }}
										>
											Template Name{" "}

										</TableCell>
										<TableCell
											className="thead"
											style={{ cursor: "pointer" }}
										>
											Description{" "}

										</TableCell>

										<TableCell
											className="thead"
											style={{ cursor: "pointer" }}
										>

											Number of Parts{" "}

										</TableCell>

                    <TableCell
											className="thead"
											style={{ cursor: "pointer" }}
										>

											Part Notation{" "}

										</TableCell>

										<TableCell
											className="thead"
											style={{ cursor: "pointer" }}
										>

											Status{" "}

										</TableCell>

										<TableCell className="thead">
											Template Actions
										</TableCell>

									</TableRow>
								</TableHead>

								<TableBody>
									{templates?.data?.templates &&  templates.data.templates.length > 0 && !templateLoading ? (
										templates.data.templates.map((template, index) => (
											<TableRow key={index}>

												<TableCell className="tData"></TableCell>

												<TableCell className="tData">
													<div className="center-vertical mg-m library-title">
														{template.name || ''}
													</div>
												</TableCell>

												<TableCell className="tData">
													<Tooltip title={template.description} placement="bottom-start" arrow>
														<div className="center-vertical mg-m library-title">
															{template.description || 'N/A'}
														</div>
													</Tooltip>
												</TableCell>

												

												<TableCell className="tData">
													<div className="center-vertical mg-m library-title">
														{template.no_of_parts || '0'}
													</div>
												</TableCell>

                        <TableCell className="tData">
													<div className="center-vertical mg-m library-title">
														{getPartNotationTypeById(template.part_notation_id) || ''}
													</div>
												</TableCell>

                        <TableCell className="tData">
													<div className="center-vertical mg-m library-title">
														{template?.status_id === 1?(
                              <Chip label="Active" color="success" />
                            )
                            :
                            (
                              <Chip label="InActive" color="error" />
                            )}
													</div>
												</TableCell>

                        <TableCell className="tData">
                          <Button
                            className="btn btn-icon action-btn  btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                            title="Edit Details"
                            onClick={()=>updateTemplate(template)}
                          />
                        </TableCell>

												


											</TableRow>
										))
									) : (
										templateLoading ? (

											<TableRow>
												<TableCell colSpan={7}>
													<Skeleton height={30} />
													<Skeleton animation="wave" height={30} />
													<Skeleton height={30} />
													<Skeleton animation="wave" height={30} />
													<Skeleton height={30} />
													<Skeleton animation="wave" height={30} />
												</TableCell>
											</TableRow>
										) : (
											<TableRow>
												<TableCell colSpan={6} align="center">
													<div>No Templates</div>
												</TableCell>
											</TableRow>
										)
									)}


								</TableBody>

							</Table>

              <div className="d-flex justify-content-end">
                <MaterialCustomTablePagination
                  totalCount={templates?.data?.total_count || 0}
                  currentPage={currentPage}
                  limit={state.limit}
                  handlePageChange={handlePageChange}
                  handleRowsPerPageChange={handleRowsPerPageChange}
                  handlePageOffsetChange={handlePageOffsetChange}
                  offset={state.offset}
                  rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                />
              </div>

              {isOpen && 
                <AddTemplate isOpen={isOpen} setIsOpen={setIsOpen} currentTemplate={currentTemplate} setCurrentTemplate={setCurrentTemplate} handlefetchAllTemplates={handlefetchAllTemplates}/>
              }
    </Box>
  )
}

export default TemplateTab